import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.searchParams.get("token");

    if (token) {
      localStorage.setItem("access_token", token);
      navigate("/scanner/Nifty500");
    }
  }, []);

  return <div>Logging you in...</div>;
};

export default AuthSuccess;
